import { render, staticRenderFns } from "./Dialog_CreateClassHour.vue?vue&type=template&id=2fea9044&scoped=true&"
import script from "./Dialog_CreateClassHour.vue?vue&type=script&lang=js&"
export * from "./Dialog_CreateClassHour.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_CreateClassHour.vue?vue&type=style&index=0&id=2fea9044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea9044",
  null
  
)

export default component.exports